import React, { useState, useRef, useEffect } from 'react';

const Music = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  // Auto-play when component mounts
  useEffect(() => {
    // Due to browser policies, we need to check if autoplay is allowed
    const startMusic = async () => {
      try {
        if (audioRef.current) {
          // Try to play
          const playPromise = audioRef.current.play();
          
          if (playPromise !== undefined) {
            playPromise
              .then(() => {
                setIsPlaying(true);
              })
              .catch(error => {
                console.log("Autoplay prevented:", error);
                // If autoplay is prevented, we keep the music paused
                setIsPlaying(false);
              });
          }
        }
      } catch (error) {
        console.log("Error playing audio:", error);
      }
    };

    startMusic();
  }, []);

  const togglePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <audio
        ref={audioRef}
        src="/music/music.mp3"
        loop
        preload="auto"
      />
      <button
        onClick={togglePlay}
        className="bg-yellow-400/20 hover:bg-yellow-400/30 text-yellow-400 p-4 rounded-full backdrop-blur-sm transition-all duration-300 hover:scale-110 group"
        aria-label={isPlaying ? 'Mute music' : 'Play music'}
      >
        {isPlaying ? (
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.536 15.536A5 5 0 0015 12v-2a4 4 0 00-4-4 4 4 0 00-4 4v2a5 5 0 001.464 3.536m9.072 0A5 5 0 0115 12v-2a4 4 0 00-4-4 4 4 0 00-4 4v2a5 5 0 01-1.464 3.536" />
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15.536a5 5 0 001.464-3.536v-2a4 4 0 014-4 4 4 0 014 4v2a5 5 0 01-1.464 3.536m-2.828.728a9 9 0 001.414-1.414m0 0a9 9 0 00-2.828-2.828" />
          </svg>
        )}
      </button>
    </div>
  );
};

export default Music; 